<div class="flex-column gap p-2">
    <app-select-input
        [form]="form"
        id="headerId"
        label="service.patterns.header"
        [staticOptions]="store.headers()"
        [autoDisplayFirst]="true"
        valueKey="id"
    ></app-select-input>
    <app-select-input
        [form]="form"
        id="footerId"
        label="service.patterns.footer"
        [staticOptions]="store.footers()"
        [autoDisplayFirst]="true"
        valueKey="id"
    ></app-select-input>

    <div>{{ 'individualPlan.print.label' | translate }}:</div>

    <app-select-input
        [form]="form"
        id="type"
        label="individualPlan.print.viewType"
        [staticOptions]="typeOptions"
        [showClear]="false"
        [autoDisplayFirst]="true"
    ></app-select-input>

    @let selectAll = form.value.type == 'allOf';
    @if (selectAll) {
        <app-date-input
            id="dateFrom"
            [form]="form"
            label="individualPlan.print.dateFrom"
            [showClear]="true"
        ></app-date-input>

        <app-date-input
            id="dateTo"
            [form]="form"
            label="individualPlan.print.dateTo"
            [showClear]="true"
        ></app-date-input>

        <app-multi-select-input
            [form]="form"
            id="tags"
            [showClear]="true"
            [staticOptions]="store.tags()"
            label="individualPlan.fields.tags"
        ></app-multi-select-input>
    }

    <app-check-input
        class="align-self-start"
        [form]="form"
        id="situation"
        label="individualPlan.fields.situation"
    ></app-check-input>

    <div class="flex gap align-items-center">
        <app-check-input
            [form]="form"
            id="withTargets"
            label="individualPlan.print.targets"
        ></app-check-input>
        <app-select-input
            [form]="form"
            id="allTargets"
            [staticOptions]="allOptions"
            [showLabel]="false"
            [showClear]="false"
            [autoDisplayFirst]="true"
            [disabled]="!form.value.withTargets"
        ></app-select-input>
    </div>

    <div class="flex gap align-items-center">
        <app-check-input
            [form]="form"
            id="withOffers"
            label="individualPlan.print.offers"
        ></app-check-input>
        <app-select-input
            [form]="form"
            id="allOffers"
            [staticOptions]="allOptions"
            [showLabel]="false"
            [showClear]="false"
            [autoDisplayFirst]="true"
            [disabled]="!form.value.withOffers"
        ></app-select-input>
    </div>

    <app-check-input
        class="align-self-start"
        [form]="form"
        id="process"
        label="individualPlan.fields.process"
    ></app-check-input>

    <app-check-input
        class="align-self-start"
        [form]="form"
        id="evaluation"
        label="individualPlan.fields.evaluation"
    ></app-check-input>

    <app-check-input
        class="align-self-start"
        [form]="form"
        [disabled]="true"
        id="work"
        label="individualPlan.print.work"
    ></app-check-input>

    <app-check-input
        class="align-self-start"
        [form]="form"
        id="archive"
        label="common.archive"
    ></app-check-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-action-buttons
        primaryButtonLabel="common.print"
        primaryButtonType="print"
        [primaryButtonDisability]="!form.value.headerId || !form.value.footerId"
        [primaryButtonLoading]="processing"
        (primaryClickEvent)="print()"
        (secondaryClickEvent)="dialogRef.close()"
    ></app-action-buttons>
</div>
